import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ThemePreviewPanel = ({ config }) => {
  const [previewMode, setPreviewMode] = useState('desktop');
  const [previewScreen, setPreviewScreen] = useState('dashboard');

  const previewModes = [
    { id: 'desktop', label: 'Desktop', icon: 'Monitor' },
    { id: 'tablet', label: 'Tablet', icon: 'Tablet' },
    { id: 'mobile', label: 'Mobile', icon: 'Smartphone' }
  ];

  const previewScreens = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'login', label: 'Login' },
    { id: 'form', label: 'Form' },
    { id: 'table', label: 'Data Table' }
  ];

  const getThemeColors = () => ({
    primary: config?.colorPalette?.primary || '#2D9B9B',
    secondary: config?.colorPalette?.secondary || '#1A7A7A',
    accent: config?.colorPalette?.accent || '#3DB8B8',
    success: config?.colorPalette?.success || '#059669',
    warning: config?.colorPalette?.warning || '#d97706',
    error: config?.colorPalette?.error || '#dc2626'
  });

  const getPreviewDimensions = () => {
    switch (previewMode) {
      case 'tablet':
        return { width: '300px', height: '400px' };
      case 'mobile':
        return { width: '250px', height: '450px' };
      default:
        return { width: '400px', height: '300px' };
    }
  };

  const renderPreviewContent = () => {
    const colors = getThemeColors();
    
    switch (previewScreen) {
      case 'login':
        return (
          <div className="p-6 bg-gradient-to-br from-secondary-50 to-secondary-100 h-full flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 shadow-lg w-full max-w-sm">
              <div className="text-center mb-6">
                <img 
                  src={config?.brandIdentity?.logoUrl || '/assets/images/image-1750685807825.png'} 
                  alt="Logo" 
                  className="h-8 w-auto mx-auto mb-2"
                />
                <h2 className="text-lg font-semibold" style={{ color: colors.primary }}>
                  {config?.brandIdentity?.companyName || 'CLAB'}
                </h2>
              </div>
              <div className="space-y-3">
                <input 
                  type="text" 
                  placeholder="Username" 
                  className="w-full px-3 py-2 border border-secondary-300 rounded text-sm"
                />
                <input 
                  type="password" 
                  placeholder="Password" 
                  className="w-full px-3 py-2 border border-secondary-300 rounded text-sm"
                />
                <button 
                  className="w-full py-2 text-white rounded font-medium text-sm"
                  style={{ backgroundColor: colors.primary }}
                >
                  Sign In
                </button>
              </div>
            </div>
          </div>
        );
      
      case 'form':
        return (
          <div className="p-4 bg-white h-full overflow-y-auto">
            <div className="mb-4">
              <h3 className="text-sm font-semibold mb-2" style={{ color: colors.primary }}>
                User Information
              </h3>
              <div className="space-y-3">
                <div>
                  <label className="block text-xs font-medium text-text-primary mb-1">Full Name</label>
                  <input type="text" className="w-full px-2 py-1 border border-secondary-300 rounded text-xs" />
                </div>
                <div>
                  <label className="block text-xs font-medium text-text-primary mb-1">Role</label>
                  <select className="w-full px-2 py-1 border border-secondary-300 rounded text-xs">
                    <option>Select role...</option>
                    <option>CLAB User</option>
                    <option>Recruiter</option>
                  </select>
                </div>
                <div className="flex space-x-2">
                  <button 
                    className="flex-1 py-1 text-white rounded text-xs font-medium"
                    style={{ backgroundColor: colors.success }}
                  >
                    Save
                  </button>
                  <button className="flex-1 py-1 border border-secondary-300 text-text-secondary rounded text-xs">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      
      case 'table':
        return (
          <div className="p-4 bg-white h-full overflow-y-auto">
            <div className="mb-3">
              <h3 className="text-sm font-semibold" style={{ color: colors.primary }}>
                Biodata Records
              </h3>
            </div>
            <div className="space-y-2">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="flex items-center justify-between p-2 bg-secondary-50 rounded text-xs">
                  <div>
                    <div className="font-medium text-text-primary">John Doe {item}</div>
                    <div className="text-text-secondary">Construction Worker</div>
                  </div>
                  <div className="flex space-x-1">
                    <span 
                      className="px-2 py-1 rounded text-white text-xs"
                      style={{ backgroundColor: item % 2 === 0 ? colors.success : colors.warning }}
                    >
                      {item % 2 === 0 ? 'Approved' : 'Pending'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      
      default:
        return (
          <div className="p-4 bg-secondary-50 h-full">
            {/* Header */}
            <div className="bg-white rounded mb-3 p-2 flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <img 
                  src={config?.brandIdentity?.logoUrl || '/assets/images/image-1750685807825.png'} 
                  alt="Logo" 
                  className="h-4 w-auto"
                />
                <span className="text-xs font-semibold" style={{ color: colors.primary }}>
                  {config?.brandIdentity?.companyName || 'CLAB'}
                </span>
              </div>
              <Icon name="User" size={14} className="text-text-secondary" />
            </div>
            
            {/* Stats Cards */}
            <div className="grid grid-cols-2 gap-2 mb-3">
              {[
                { label: 'Total Users', value: '1,247', color: colors.primary },
                { label: 'Pending', value: '156', color: colors.warning },
                { label: 'Approved', value: '892', color: colors.success },
                { label: 'Rejected', value: '23', color: colors.error }
              ].map((stat, index) => (
                <div key={index} className="bg-white rounded p-2">
                  <div className="text-xs text-text-secondary">{stat.label}</div>
                  <div className="text-sm font-bold" style={{ color: stat.color }}>
                    {stat.value}
                  </div>
                </div>
              ))}
            </div>
            
            {/* Action Buttons */}
            <div className="flex space-x-2">
              <button 
                className="flex-1 py-1 text-white rounded text-xs font-medium"
                style={{ backgroundColor: colors.primary }}
              >
                Add User
              </button>
              <button className="flex-1 py-1 border border-secondary-300 text-text-secondary rounded text-xs">
                Export
              </button>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="bg-surface border border-secondary-200 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-text-primary">Live Preview</h3>
        <Icon name="Eye" size={20} className="text-[#2D9B9B]" />
      </div>

      {/* Preview Mode Selector */}
      <div className="mb-4">
        <div className="flex space-x-1 bg-secondary-100 rounded-lg p-1">
          {previewModes.map((mode) => (
            <button
              key={mode.id}
              onClick={() => setPreviewMode(mode.id)}
              className={`flex items-center space-x-1 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                previewMode === mode.id
                  ? 'bg-white text-text-primary shadow-sm'
                  : 'text-text-secondary hover:text-text-primary'
              }`}
            >
              <Icon name={mode.icon} size={14} />
              <span>{mode.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Screen Type Selector */}
      <div className="mb-4">
        <select
          value={previewScreen}
          onChange={(e) => setPreviewScreen(e.target.value)}
          className="w-full px-3 py-2 border border-secondary-300 rounded-lg text-sm focus:ring-2 focus:ring-[#2D9B9B] focus:border-[#2D9B9B]"
        >
          {previewScreens.map((screen) => (
            <option key={screen.id} value={screen.id}>
              {screen.label}
            </option>
          ))}
        </select>
      </div>

      {/* Preview Window */}
      <div className="bg-secondary-100 rounded-lg p-4 flex items-center justify-center">
        <div 
          className="bg-white rounded-lg shadow-lg overflow-hidden border border-secondary-300"
          style={getPreviewDimensions()}
        >
          {renderPreviewContent()}
        </div>
      </div>

      {/* Theme Summary */}
      <div className="mt-6 pt-4 border-t border-secondary-200">
        <h4 className="text-sm font-medium text-text-primary mb-3">Current Theme</h4>
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Brand:</span>
            <span className="text-text-primary font-medium">
              {config?.brandIdentity?.companyName || 'CLAB'}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Primary Color:</span>
            <div className="flex items-center space-x-2">
              <div 
                className="w-4 h-4 rounded border border-secondary-300"
                style={{ backgroundColor: getThemeColors().primary }}
              />
              <span className="text-text-primary font-mono text-xs">
                {getThemeColors().primary}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary">Font:</span>
            <span className="text-text-primary font-medium">
              {config?.typography?.fontFamily?.body || 'Inter'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemePreviewPanel;